import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { dateMethods, DATE_FORMATS } from '@utils/dates/dateMethods';

const TicketDetail = ({ ticketData }) => {
    const { getDateFormatted } = dateMethods;
    let createdDate = getDateFormatted(ticketData.created, DATE_FORMATS.MMM_DD_YYY);
    return (
        <Fragment>
            <div className="ticket-header-styled text-left">
                <h3 className="heading">
                    <FormattedMessage id='ticket.detail.header'/>
                    <strong><FormattedMessage id='ticket.table_cell.ticket_number' values={{ ticketNumber: ticketData.number }}/></strong>
                </h3>
            </div>
            <div className='container-grid'>
                <dl className='ticket-summary grid-row'>
                    <dt className='ticket-label text-right grid-col-2'>
                        <FormattedMessage id='ticket.detail.ticket_type'/>
                    </dt>
                    <dd className='ticket-description text-left grid-col-10'>
                        <FormattedMessage id='ticket.detail.ticket_type.data' values={{ ticketType: ticketData.type }}/>
                    </dd>
                    <dt className='ticket-label text-right grid-col-2'>
                        <FormattedMessage id='ticket.detail.created_for'/>
                    </dt>
                    <dd className='ticket-description text-left grid-col-10'>
                        <FormattedMessage id='ticket.table_cell.user' values={{ user: ticketData.createdFor }}/>
                    </dd>
                    <dt className='ticket-label text-right grid-col-2'>
                        <FormattedMessage id='ticket.detail.creation_date'/>
                    </dt>
                    <dd className='ticket-description text-left grid-col-10'>
                        <FormattedMessage id='ticket.table_cell.creation_time' values={{ creationTime: createdDate }}/>
                    </dd>
                    <dt className='ticket-label text-right grid-col-2'>
                        <FormattedMessage id='ticket.table_title.status'/>
                    </dt>
                    <dd className='ticket-description text-left grid-col-10'>
                        <FormattedMessage id='ticket.table_cell.status' values={{ status: ticketData.status }}/>
                    </dd>
                    <dt className='ticket-label text-right grid-col-2'>
                        <FormattedMessage id='ticket.detail.description'/>
                    </dt>
                    <dd className='ticket-description text-left grid-col-10'>
                        <p data-automation-id='content_ticket_description' dangerouslySetInnerHTML={{ __html: ticketData.details }}></p>
                    </dd>
                </dl>
            </div>
        </Fragment>


    );
};

export default TicketDetail;